export const SET_ENGINES = (state, payload) => {
  state.engines = payload;
}
